import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';

import { UserAccountData } from '@hdms/shared/page-frame/types';

import { ContactBodyComponent } from '../../header-contact/contact-body/contact-body.component';

@Component({
  selector: 'shrd-pf-ft-contact-popover-content',
  templateUrl: './contact-popover-content.component.html',
  styleUrls: ['./contact-popover-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactPopoverContentComponent {
  @Input() userData: UserAccountData;

  @ViewChild(ContactBodyComponent, { read: ElementRef, static: true })
  readonly contactBody: ElementRef<HTMLElement>;
}
